import React, {useState, useEffect} from 'react'
import imageUrl from  '../assets/rec.jpeg'
import image from  '../assets/logo.png'


 function InscriptionForm() {
  
  //const imageUrl = 'rec.jpeg';

const [nom, setNom] = useState('');
const [submitted, setSubmitted] = useState(false);
const [startTime, setStartTime] = useState(null); // Temps de début
  const [endTime, setEndTime] = useState(null); // Temps de fin
  const [userTime, setUserTime] = useState(0); // Durée
 
  useEffect(() => {
    // Enregistre le temps lorsque le formulaire est monté
    setStartTime(Date.now());
  }, []);
  useEffect(() => {
    if (startTime && endTime) {
      const timeTaken =  endTime - startTime;
      setUserTime(timeTaken);
    }
  }, [endTime]); 
  
  const handleSubmit = async(e) => {
    e.preventDefault();
  try {
  
    setEndTime(Date.now());
    setSubmitted(true);
  } catch (error) {
    console.error('Erreur lors de l\'envoi des données :', error);
  }
  };
  
  const handleRestart = () => {
    setNom('');
    setSubmitted(false);
    setStartTime(null);
    setEndTime(null);
    setUserTime(0);
  };

  const formatTime = (timeInMillis) => {
    const totalSeconds = Math.floor(timeInMillis / 1000);
    const minutes = Math.floor(totalSeconds / 60);
    const seconds = totalSeconds % 60;
    return `${minutes} min ${seconds} seconde${seconds !== 1 ? 's' : ''}`;
  };
  const getMessageAndColor = () => {
    if (userTime < 60000) {
      return { message: "Excellent temps", color: "green" };
    } else if (userTime >= 60000 && userTime <= 120000) {
      return { message: "Temps moyen", color: "orange" };
    } else {
      return { message: "Vous avez mis trop de temps (ressayez le test)", color: "red" };
    }
  };
  return (
    <>
    <section className="section" data-class="transheader bgcolor">
      
      <div className="container">
        <div className="row">
          <div className="content col-md-12 col-sm-12 blog-alt">
            <div className="blog-box clearfix">
              <div className="contact_form comment-form">
              {!submitted ? ( <form method="post" enctype="multipart/form-data" action="/process-inscription" onSubmit={handleSubmit} className='mx-auto mt-20'
              style={{ backgroundColor: 'white', padding: '20px', borderRadius: '5px', boxShadow: '0 2px 10px rgba(0,0,0,0.1)' }}>
                  <div className="row">
                    <div className="col-md-8">
                      <div className="form-group" style={{ marginTop: '20px' }}>
                        <label style={{fontWeight: 'bold'}} >
                          Email
                      
                        
                       <br/> <span className="tooltip-back">
          C'est par courriel que vous recevrez votre convocation et <br />
          votre attestation de résultats, assurez-vous donc que votre adresse <br />
          électronique est correcte et active.
        </span></label>
                        <input
                          type="email"
                          id="email"
                          name="utilisateur[email]"
                          className="form-control"
                          placeholder="Entrez votre email"
                          required
                          
                        />
                        
                      </div>
            <div className='row' style={{justifyContent: 'space-between'}}>
<div className='col-md-6 col-sm-12 row justify-content-center-align-items-center inscription-avatar-row'>
    <div className='col-md-12 col-sm-12 form-group dashed-block-avatar'>
        <label style={{fontWeight: 'bold'}}>
            photo 4*4
             <label><br/>
           
        <div className="tooltip-back">couleur sur fond blanc du candidat
        <span style={{color : 'red'}}>
            taille limite 2Mo
        </span> </div>
      
                <input type='file' name='kyc[avatar]'
                className='form-control'
                accept="image/*" required/>
            </label>
            </label>
        
    </div>
</div>
            </div>
            <div className='col-md-6 col-sm-12 inscription-avatar-column-field'>
            <div className="form-group">
            <label  style={{fontWeight: 'bold'}}>
            Nom(s)
            <span className="required">*</span>
           <br/> <span
              className="pull-right tooltip_flip tooltip-effect-1"
              href="javascript:void(0);"
            >
              <i className="fa fa-question"></i>
              <span className="tooltip-content-flip">
                <span className="tooltip-back">
                  Renseignez tous vos noms
                </span>
              </span>
            </span>
          </label>
          <input type="text" id="name"  value={nom} className="form-control" placeholder="Entrer votre  nom" required   onChange={(e) => setNom(e.target.value)}  />

            </div>
            <div className="form-group">
            <label style={{fontWeight: 'bold'}}>
            Prénom(s)
          <span className="required">*</span>
         <br/> <span className="pull-right tooltip_flip tooltip-effect-1" href="javascript:void(0);">
            <i className="fa fa-question"></i>
            <span className="tooltip-content-flip">
              <span className="tooltip-back">
                Renseignez tous vos prénoms
              </span>
            </span>
          </span>
                </label>  
                <input type="text" id="firstname" name="utilisateur[firstname]" className="form-control" placeholder="Entrer votre prenom" required />
  
            </div>

    </div>
    <div className="col-md-6 col-sm-12 form-group">
      <label style={{fontWeight: 'bold'}}>
        Mot de passe
        <span className="required">*</span>
       <br/> <span className="pull-right tooltip_flip tooltip-effect-1" href="javascript:void(0);">
          <i className="fa fa-question"></i>
          <span className="tooltip-content-flip">
            <span className="tooltip-back">
              Le mot de passe garantit un accès sécurisé à votre<br/> espace candidat,ce qui signifie que seules les personnes ayant <br/>connaissance du mot de passe peuvent se connecter à votre compte.<br/> Veuillez à bien sauvegarder votre mot de passe.
            </span>
          </span>
        </span>
      </label>
      <input type="password" id="password" name="utilisateur[password]" className="form-control" placeholder="Entrer un mot de passe " required  minLength="8"/>
au moins huit caracteres
                    </div>
                    <div className="col-md-6 col-sm-12 form-group">
      <label style={{fontWeight: 'bold'}}>
        Date de naissance
        <span className="required">*</span>
       <br/> <span className="pull-right tooltip_flip tooltip-effect-1" href="javascript:void(0);">
          <i className="fa fa-question"></i>
          <span className="tooltip-content-flip">
            <span className="tooltip-back">
              Répondre de la manière suivante: JJ/MM/AAAA (Ex: 01/01/2023)
            </span>
          </span>
        </span>
      </label>
      <input type="date" id="birthdate" name="utilisateur[birthdate]" className="form-control" placeholder="" required />
    </div>
    <div className="col-md-6 col-sm-12 form-group">
      <label style={{fontWeight: 'bold'}}>Pays de naissance<span className="required">*</span></label>
      <select name="utilisateur[birthPlace]" className="form-control tom-select-element" required>
        <option value="Cameroun" selected>Cameroun</option>
        <option value="Côte d&#039;Ivoire">Côte d&#039;Ivoire</option>
        <option value="Éthiopie">Éthiopie</option>
        <option value="Gabon">Gabon</option>
        <option value="Gambie">Gambie</option>
        <option value="Ghana">Ghana</option>
        <option value="Guinée">Guinée</option>
      </select>
    </div>
    <div className="row">
      <div className="col-md-6 col-sm-12 form-group">
        <label style={{fontWeight: 'bold'}}>
          Sexe<span className="required">*</span>
        </label>
        <select
          name="utilisateur[sexe]"
          className="form-control tom-select-element"
          required
        >
          <option value="masculin">Homme</option>
          <option value="feminin">Femme</option>
          <option value="non binaire">Non Binaire</option>
        </select>
      </div>
      <div className="col-md-6 col-sm-12 form-group">
        <label style={{fontWeight: 'bold'}}>
          Nationalité<span className="required">*</span>
        </label>
        <select
          name="utilisateur[nationalite]"
          className="form-control tom-select-element"
          required
        >
          <option value="Afrique du Sud">Afrique du Sud</option>
          <option value="Algérie">Algérie</option>
          <option value="Bénin">Bénin</option>
          <option value="Burkina Faso">Burkina Faso</option>
          <option value="Cameroun" selected>
            Cameroun
          </option>
          <option value="Côte d&#039;Ivoire">Côte d&#039;Ivoire</option>
          <option value="Égypte">Égypte</option>
          <option value="Éthiopie">Éthiopie</option>
          <option value="Gabon">Gabon</option>
        </select>
      </div>
      
      <div className="col-md-6 col-sm-12 form-group">
        <label style={{fontWeight: 'bold'}}>
          Téléphone<span className="required">*</span>
        </label>
        <input
          id="phoneNumber"
          type="text"
          name="utilisateur[phoneNumber]"
          className="form-control"
          placeholder="660000000"
          required
        />
      </div>
      <div className="col-md-6 col-sm-12 form-group">
        <label style={{fontWeight: 'bold'}}>
          Langue usuelle<span className="required">*</span>
          <span
            className="pull-right tooltip_flip tooltip-effect-1"
            href="javascript:void(0);"
          >
          <br/>  <i className="fa fa-question"></i>
            <span className="tooltip-content-flip">
              <span className="tooltip-back">
                Il s'agit de la langue que vous utilisez le plus dans vos activités quotidiennes
              </span>
            </span>
          </span>
        </label>
        <select
          name="utilisateur[langueUsuelle]"
          className="form-control tom-select-element"
          required
        >
          <option value="anglais">anglais</option>
          <option value="anglais moyen (1100-1500)">anglais moyen (1100-1500)</option>
          <option value="anglo-saxon (ca.450-1100)">anglo-saxon (ca.450-1100)</option>
          <option value="français" selected>français</option>
          <option value="français ancien (842-ca.1400)">français ancien (842-ca.1400)</option>
          <option value="français moyen (1400-1600)">français moyen (1400-1600)</option>
        </select>
      </div>
      <div className="col-md-6 col-sm-12 form-group">
        <label style={{fontWeight: 'bold'}}>
          Code candidat
          <span
            className="pull-right tooltip_flip tooltip-effect-1"
            href="javascript:void(0);"
          >
          <br/>  <i className="fa fa-question"></i>
            <span className="tooltip-content-flip">
              <span className="tooltip-back">
                Avez-vous déjà passé ce test? sI oui, Indiquez votre code candidat
              </span>
            </span>
          </span>
        </label>
        <input
          type="text"
          name="utilisateur[codeCandidat]"
          className="form-control"
          placeholder="Avez-vous déjà passé le DELF?  sI oui, Indiquez votre code candidat"
        />
      </div>
      <div className="col-md-6 col-sm-12 form-group">
        <label style={{fontWeight: 'bold'}}>
          Types de document<span className="required">*</span>
        </label>
        <select
          className="form-control"
          name="utilisateur[document]"
          required
        >
          <option value="cni">Carte national d'identité</option>
          <option value="passeport">Passeport</option>
        </select>
      </div>
      <div className="col-md-6 col-sm-12 form-group">
        <label style={{fontWeight: 'bold'}}>
          Numéro de CNI ou Passeport<span className="required">*</span>
        </label>
        <input
          type="text"
          name="utilisateur[numeroDocument]"
          className="form-control"
          placeholder=""
          required
        />
      </div>
      <div className="col-md-6 col-sm-12 form-group">
        <label style={{fontWeight: 'bold'}}>
          Face avant<span className="required">*</span>
          <span style={{ color: 'red' }}><br/>Taille limite 2Mo</span>
          <span
            className="pull-right tooltip_flip tooltip-effect-1"
            href="javascript:void(0);"
          >
            <i className="fa fa-question"></i>
            <span className="tooltip-content-flip">
              <span className="tooltip-back">
                IMAGE(S) PHOTOCOPIE Recto/Verso DE LA PIECE D'IDENTITE
              </span>
            </span>
          </span>
        </label>
        <input
          type="file"
          name="kyc[frontSidePhoto]"
          className="form-control"
          accept="image/*"
          required
        />
      </div>
      <div className="col-md-6 col-sm-12 form-group">
        <label style={{fontWeight: 'bold'}}>
          Face arrière
          <span style={{ color: 'red' }}><br/>Taille limite 2Mo</span>
        </label>
        <input
          type="file"
          name="kyc[backSidePhoto]"
          className="form-control"
          accept="image/*"
        />
      </div>
      <div className="col-md-12 col-sm-12 ">
        <small>
          TELECHARGEZ<span className="required">*</span>
          <br />
        </small>
        <ul>
          <li>PHOTOCOPIE Recto/Verso DE LA PIECE D'IDENTITE</li>
          <li>01 PHOTO 4*4 couleur sur fond blanc</li>
        </ul>
      </div>
      <div className="col-md-12 col-sm-12 form-check form-group">
        <input
          className="form-check-input"
          type="checkbox"
          value="1"
          name="utilisateur[authorisationCandidat]"
          id="authorisationCandidat"
          defaultChecked
        />
        <label className="form-check-label " htmlFor="authorisationCandidat" style={{fontWeight: 'bold'}}>
          J'autorise IFC à utiliser mes données pour des besoins de formation
        </label>
      </div>


    </div>

</div>      
                  </div>
                  
               
     
  
      <div className="col-md-4 col-sm-12 text-center">
        <div className="seo-details">
          <div className="website-screen">
            <img
              src={image} style={{
                width: '80px',
                height: '80px',}}
              alt="examen TEF-Canada IFC."
              className="img-responsive"
            />
          </div>
        </div>
      </div>
  
    
      <div className="pricing-box clearfix">
        <div className="pricing-header">
          <h4 style={{ color: '#595959' }}>
            Test d&#039;évaluation de français pour le Canada (TEF-Canada)
          </h4>
        </div>
      </div>
  
      <div className="pricing-details">
        <ul>
          <li style={{ borderTop: '1px solid #efefef' }}>
            01 inscription
            <span>210 000 FCFA</span>
            <span>
              <i className="fa fa-check"></i>
            </span>
          </li>
        </ul>
      </div>
 
      <div className="pricing-top" style={{ padding: '20px 0', color: '#595959' }}>
        <p style={{ padding: 0 }}>Total TTC 210 000 FCFA</p>
      </div>
  
      <div className="form-group">
        <p className="captcha">
          <label>je ne suis pas un robot</label>
          <input name="Captcha" id="captcha" type="checkbox" placeholder="pour verifier que vous etes humain" value="" required/>
          <img src={imageUrl} alt="recaptcha"  className="img-responsive"
                      style={{
                        width: '80px',
                        height: '80px',}}/>
        </p>
      </div>
  
      <div className="pricing-footer text-center">
        <div className="row">
          <div className="col-sm-12">

            
          </div>
        </div>
        
         
    
      </div>
  
      
     <button type="submit" className="rounded-button">S'incrire</button>
       
      </form>
                 ) : (
                  <div>
                    {userTime && (
            <h1 style={{ color: getMessageAndColor().color }}>
              {getMessageAndColor().message}
            </h1>
          )}
                  <h2>Félicitations Mr/Mme {nom}, vous avez réussi! <br/>
                  le Temps pris pour remplir le formulaire : {formatTime(userTime)}</h2>
                  
                  <button onClick={handleRestart} className="rounded-button">Recommencer le test</button>
          <a href="https://objectifcanada-tcf.com/signin?callbackUrl=/test?type=TCF">
            <button className="rounded-button">Débuter la préparation</button>
          </a>

                  </div>
                )}
              </div>
            </div>
          </div>
         
        </div>
      </div>
     
    
     
      
      </section>
      
     
     
      </>
  );
};
  
export default InscriptionForm;
